import { collection, addDoc , getDocs, doc, deleteDoc, updateDoc, query, where, getDoc, setDoc } from "firebase/firestore"; 
import { db } from "../firebaseData";
import moment from "moment";

import packageJson from '../../package.json';
export const version = packageJson.version;

export const createNewMember = async (collectionName: string, data: any)=>{
    const docRef = await addDoc(collection(db, collectionName), data);
    if(docRef.id){
        return docRef
    }else{
        return null
    }
}

export const getMember = async (collectionName: string, documentId:string) => {
    const documentRef = doc(db, collectionName, documentId);
    const documentSnapshot = await getDoc(documentRef);
    if (documentSnapshot.exists()) {
      const data = documentSnapshot.data();
      return data
    } else {
      return null
    }
  };

export const updateMember = async (collectionName: string, memberId: string, data: any) => {
    const washingtonRef = doc(db, collectionName, memberId);
    await updateDoc(washingtonRef, data);
}

export const deleteMember = async(collectionName: string, memberId: string)=>{
    await deleteDoc(doc(db, collectionName, memberId));
}

export const getFamilyMembers = async(collectionName: string)=>{
    const querySnapshot = await getDocs(collection(db, collectionName));
    let array:any = querySnapshot.docs.map((doc)=>{
        let data:any = {...doc.data(),id:doc.id}
        if(data.birthday && data.birthday.seconds){
            data.formatBirthday = moment.unix(data.birthday.seconds).format("DD/MM/YYYY");
        }
        if(data.deadthday && data.deadthday.seconds){
            data.formatDeadthday = moment.unix(data.deadthday.seconds).format("DD/MM/YYYY");
        }
        return data
    })
    return array
}

export const findDocumentByField = async(collectionName:string, fieldName:string, fieldValue:any)=>{
    const q = query(collection(db, collectionName), where(fieldName, '==', fieldValue));
    try {
      const querySnapshot = await getDocs(q);
      let array = querySnapshot.docs.map((doc)=>({id:doc.id,...doc.data()}))
      return array
    } catch (error) {
      console.error('Error searching for document:', error);
      return []
    }
}

export const formatDate = (timestamp: any) => {
    if (!timestamp) return 'no data';
    return moment(timestamp.toDate()).format('DD/MM/YYYY');
  };

export const saveSetting = async (documentId: string, data: any) => {
    const documentRef = doc(db, 'settings', documentId);
    await setDoc(documentRef, data, { merge: true });
};